// extracted by mini-css-extract-plugin
export default {"td":"ConsultaClientes_td__tjsKR"};